<ng-container *ngIf="viewModel$ | async as viewModel">
  <div
    class="details"
    (click)="
      store.dispatch(
        actions.invoiceComponentClicked({ invoiceId: viewModel.invoice.id })
      )
    "
  >
    <i class="pi pi-file"></i>
    <div>
      <div class="document-name">
        <span>{{ viewModel.name }}</span>
        <p-tag
          *ngFor="let tag of viewModel.tags"
          rounded="true"
          [style]="{
            backgroundColor: tag.backgroundColor,
            color: tag.color,
          }"
          [value]="tag.text"
          styleClass="p-ml-2"
        ></p-tag>
      </div>
      <div>Remaining balance: {{ viewModel.balance }}</div>
    </div>
  </div>
  <div class="buttons">
    <p-button
      (onClick)="
        store.dispatch(
          actions.sendInvoiceButtonClicked({ invoiceId: viewModel.invoice.id })
        )
      "
      [icon]="viewModel.sendButtonIcon"
      [label]="viewModel.sendButtonLabel"
      [disabled]="viewModel.sendButtonDisabled"
      [pTooltip]="viewModel.sendButtonDisabledTooltip"
      styleClass="p-mr-2"
    ></p-button>
    <p-button
      icon="pi pi-ellipsis-v"
      text="true"
      (click)="
        store.dispatch(
          actions.openInvoiceActionsMenuButtonClicked({
            invoiceId: viewModel.invoice.id,
          })
        );
        menu.toggle($event)
      "
    ></p-button>
    <p-menu
      #menu
      [popup]="true"
      appendTo="body"
      [model]="viewModel.actionsMenu"
    ></p-menu>
  </div>
</ng-container>
